/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { useState } from 'react';
import PropTypes from 'prop-types';

import { noop } from 'app/shared/utils/utils';

import { DesktopBanner } from './DesktopBanner/DesktopBanner';
import { MobileBanner } from './MobileBanner/MobileBanner';

export const UserSurvey = ({
  isDesktopVariant,
  isMobileVariant,
  threshold,
  onFormSubmit,
  onClose,
  setFormSubmitted,
  areCookiesAccepted,
  submitted,
  target,
  openOverlay,
  closeOverlay,
}) => {
  const [done, setDone] = useState(false);

  const finishSubmit = () => {
    setDone(true);
    setFormSubmitted(areCookiesAccepted);
  };

  if (isMobileVariant)
    return (
      <MobileBanner
        openOverlay={openOverlay}
        closeOverlay={closeOverlay}
        threshold={threshold}
        onFormSubmit={onFormSubmit}
        finishSubmit={finishSubmit}
        onClose={onClose}
        areCookiesAccepted={areCookiesAccepted}
        submitted={submitted}
        target={target}
      />
    );

  if (isDesktopVariant)
    return (
      <DesktopBanner
        threshold={threshold}
        onFormSubmit={onFormSubmit}
        finishSubmit={finishSubmit}
        done={done}
        onClose={onClose}
        areCookiesAccepted={areCookiesAccepted}
        submitted={submitted}
      />
    );

  return null;
};

UserSurvey.propTypes = {
  isDesktopVariant: PropTypes.bool,
  isMobileVariant: PropTypes.bool,
  areCookiesAccepted: PropTypes.bool,
  threshold: PropTypes.number.isRequired,
  onFormSubmit: PropTypes.func,
  setFormSubmitted: PropTypes.func,
  onClose: PropTypes.func,
  submitted: PropTypes.bool,
  openOverlay: PropTypes.func,
  closeOverlay: PropTypes.func,
  target: PropTypes.string.isRequired,
};

UserSurvey.defaultProps = {
  isDesktopVariant: false,
  isMobileVariant: false,
  areCookiesAccepted: false,
  onFormSubmit: noop,
  setFormSubmitted: noop,
  submitted: false,
  onClose: noop,
  openOverlay: noop,
  closeOverlay: noop,
};
